/* Mayur — PDP: option pickers (size, frame…) + AJAX add to collection */

function initProductForm() {
  const form = document.querySelector('[data-product-form]');
  if (!form) return;

  const variantScript = form.querySelector('[data-variant-data]');
  let variants = [];
  try {
    variants = variantScript ? JSON.parse(variantScript.textContent) : [];
  } catch {
    variants = [];
  }

  const idInput = form.querySelector('[name="id"]');
  const addButton = form.querySelector('[data-add-button]');
  const priceTarget = form.querySelector('[data-add-price]');
  const labelTarget = form.querySelector('[data-add-label]');
  const errorTarget = form.querySelector('[data-form-error]');
  const optionButtons = Array.from(form.querySelectorAll('[data-option-value]'));
  const defaultLabel = labelTarget ? labelTarget.textContent : '';

  // Pre-select the option values of the initially selected variant
  const selected = [];
  optionButtons.forEach((btn) => {
    if (btn.classList.contains('is-selected')) {
      selected[parseInt(btn.getAttribute('data-option-index'), 10)] = btn.getAttribute('data-option-value');
    }
  });

  const findVariant = () =>
    variants.find((v) => v.options.every((opt, i) => opt === selected[i]));

  const syncVariant = () => {
    if (!variants.length) return;
    const variant = findVariant();
    if (errorTarget) errorTarget.textContent = '';
    if (!variant) {
      addButton.disabled = true;
      if (labelTarget) labelTarget.textContent = addButton.getAttribute('data-unavailable-label');
      if (priceTarget) priceTarget.textContent = '';
      return;
    }
    idInput.value = variant.id;
    if (priceTarget) priceTarget.textContent = variant.price;
    if (variant.available) {
      addButton.disabled = false;
      if (labelTarget) labelTarget.textContent = defaultLabel;
    } else {
      addButton.disabled = true;
      if (labelTarget) labelTarget.textContent = addButton.getAttribute('data-sold-out-label');
    }
  };

  optionButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const i = parseInt(btn.getAttribute('data-option-index'), 10);
      optionButtons
        .filter((b) => parseInt(b.getAttribute('data-option-index'), 10) === i)
        .forEach((b) => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');
      selected[i] = btn.getAttribute('data-option-value');
      syncVariant();
    });
  });

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const variant = findVariant();
    if (!variant || !variant.available) return;

    addButton.disabled = true;

    try {
      await window.MayurCart.addAndOpen(new FormData(form));
      // "Added to your collection ✓" for 2s, matching the prototype
      if (labelTarget && addButton.getAttribute('data-added-label')) {
        labelTarget.textContent = addButton.getAttribute('data-added-label');
        if (priceTarget) priceTarget.textContent = '';
        window.setTimeout(() => {
          labelTarget.textContent = defaultLabel;
          const current = findVariant();
          if (priceTarget && current) priceTarget.textContent = current.price;
        }, 2000);
      }
    } catch (err) {
      if (errorTarget) errorTarget.textContent = err.message;
      // Fallback: let Shopify handle the add natively
      form.submit();
    } finally {
      addButton.disabled = false;
    }
  });

  if (optionButtons.length) syncVariant();
}

initProductForm();
